import React, { Component } from "react";
import './App.scss';
import Header from './components/Header/Header'
import MapComponent from './components/MapComponent/MapComponent';
import BurgerMenu from './components/BurgerMenu/BurgerMenu';
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import { addUser, setDataMenuStatus, setDataVisibilityArray, setDataListVisibilityArray, setNavtexList, setChildrenList, getDrillShipLastLocationsList, initializeSetBoundFnc } from "./redux/actions";
import { getInitialDatasetValue } from './data/DATASET';
class App extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    getInitialDatasetValue() //set initial dataset values globally
    // for (let [key, value] of sayings) {
    //   console.log(key + ' goes ' + value);
    // }
    this.props.setNavtexList();
    this.props.getDrillShipLastLocationsList();
  }
  render() {
    const { isDataMenuOpen, setDataMenuStatus, dataVisibilities, dataVisibilityList, setDataVisibilityArray, setDataListVisibilityArray, childrenData, navtexList, loading, setChildrenList, initializeSetBoundFnc, setBoundsDelegateFnc } = this.props;
    return (
      <div className="App">
        <Header isDataMenuOpen={isDataMenuOpen} setDataMenuStatus={setDataMenuStatus} />
        <BurgerMenu setBoundsDelegateFnc={setBoundsDelegateFnc} setChildrenList={setChildrenList} childrenData={childrenData} dataVisibilities={dataVisibilities} setDataVisibilityArray={setDataVisibilityArray} isDataMenuOpen={isDataMenuOpen} setDataMenuStatus={setDataMenuStatus} newDataVisibilities={dataVisibilityList} newSetDataListVisibilities={setDataListVisibilityArray} />
        <MapComponent initializeSetBoundFnc={initializeSetBoundFnc} navtexList={navtexList} isDataMenuOpen={isDataMenuOpen} setDataMenuStatus={setDataMenuStatus} dataVisibilities={dataVisibilities} newDataVisibilities={dataVisibilityList} childrenData={childrenData} />
        {loading ? <div style={{ zIndex: 999999, position: "fixed", top: "20%", left: "40%" }} ><CircularProgress color="secondary" /></div> : <div></div>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const users = state.get("users");
  const isDataMenuOpen = state.get("isDataMenuOpen");
  const dataVisibilities = state.get("dataVisibilities");
  const dataVisibilityList = state.get("dataVisibilityList");
  const childrenData = state.get("childrenData");
  //state.getIn(['childrenData', 'componentList'])
  const navtexList = state.get("navtexList");
  const loading = state.get("loading");
  const setBoundsDelegateFnc = state.get("setBoundsDelegateFnc");
  return { users, isDataMenuOpen, dataVisibilities, dataVisibilityList, childrenData, navtexList, loading, setBoundsDelegateFnc };
}
export default connect(mapStateToProps, { addUser, setDataMenuStatus, setDataVisibilityArray, setDataListVisibilityArray, setNavtexList, setChildrenList, getDrillShipLastLocationsList, initializeSetBoundFnc })(App);
